<div
  class="pnl-stock"
  [class.open]="open"
  infiniteScroll
  [fromRoot]="true"
  [infiniteScrollDistance]="2"
  [infiniteScrollThrottle]="20"
  [infiniteScrollContainer]="selector"
  (scrolled)="onScroll()"
>
  <header>
    <h1>Produtos</h1>
    <a class="dnone-sm" [routerLink]="['/app/produto']">Cadastrar</a>
    <a (click)="newProductDetail()" class="dflex-sm"><span></span></a>
    <button (click)="onExport()" type="button" class="btn btn-primary-outline">
      <i class="ic ic-export"></i> Exportar
    </button>
    <button (click)="onImport()" type="button" class="btn btn-primary-outline">
      <fa-icon [icon]="faFileImport"></fa-icon> Importar
    </button>
  </header>
  <section class="pnl">
    <ul class="tabs">
      <li
        class="todos"
        (click)="changeTab('todos')"
        [class.active]="tab == 'todos'"
      >
        <a>
          <h4>{{ num_todos }}</h4>
          <strong>Todos</strong>
        </a>
      </li>
      <li
        class="promocao"
        (click)="changeTab('promocao')"
        [class.active]="tab == 'promocao'"
      >
        <a>
          <span>{{ num_promocao }}</span>
          <strong>Em promoção</strong>
        </a>
      </li>
      <li
        class="sem-estoque"
        (click)="changeTab('sem-estoque')"
        [class.active]="tab == 'sem-estoque'"
      >
        <a>
          <span>{{ num_sem_estoque }}</span>
          <strong>Sem estoque</strong>
        </a>
      </li>
    </ul>
    <div
      class="produtos"
      [class.todos]="tab == 'todos'"
      [class.promocao]="tab == 'promocao'"
      [class.baixo-estoque]="tab == 'baixo-estoque'"
      [class.ativos]="tab == 'ativos'"
      [class.sem-estoque]="tab == 'sem-estoque'"
    >
      <div
        class="produto"
        *ngFor="let product of products; let i = index"
        (click)="openDetail(product, i)"
        [class.active]="product.idproduto_estabelecimento == openid"
      >
        <figure>
          <img
            [src]="ajustUrl(product.image)"
            onerror="this.onerror=null;this.src='/assets/img/produto_sem_foto.png'"
          />
        </figure>
        <div class="descricao">
          <span>{{ product.descricao }}</span
          ><strong>{{
            product.codbarra | mask: "0 000000 000000? 00000 0"
          }}</strong>
        </div>
        <div class="right">
          <div
            *ngIf="product.ofertas && product.ofertas.length > 0"
            class="promocoes"
          >
            <b *ngFor="let oferta of product.ofertas" class="promocao"
              ><span *ngIf="oferta.comprando > 1 && oferta.multiplo == 'N'"
                >A partir de {{ oferta.comprando }} un pague&nbsp;</span
              ><span *ngIf="oferta.comprando > 1 && oferta.multiplo == 'S'"
                >A cada {{ oferta.comprando }} un pague&nbsp;</span
              >R$ {{ oferta.preco | number: ".2" }}</b
            >
          </div>
          <b
            *ngIf="
              product.estoque <= lower_stock &&
              product.estoque > 0 &&
              product.estoque_infinito == 'N'
            "
            class="baixo-estoque"
            >Estoque baixo</b
          >
          <b
            *ngIf="product.estoque == 0 && product.estoque_infinito == 'N'"
            class="sem-estoque"
            >Sem estoque</b
          >
          <span class="preco"
            >&nbsp;R$ {{ product.preco | number: ".2"
            }}{{
              product.forma_venda != "U" ? "&nbsp;" + product.forma_venda : ""
            }}&nbsp;</span
          >
        </div>
      </div>
      <div class="produtos-loading" *ngIf="loadingProduct && !loadingTab">
        <div class="loadingio-spinner-eclipse-cz3y1wre1nd">
          <div class="ldio-ns36390yc">
            <div></div>
          </div>
        </div>
      </div>
    </div>
    <div class="tab-loading" *ngIf="loadingTab">
      <div class="loadingio-spinner-eclipse-cz3y1wre1nd">
        <div class="ldio-ns36390yc">
          <div></div>
        </div>
      </div>
    </div>
  </section>
  <aside id="detailProduct" class="detail">
    <form
      *ngIf="!isMobile"
      [formGroup]="produtoFrm"
      (ngSubmit)="onSubmit()"
      novalidate
    >
      <header [class.dnone]="changeDetail">
        <a [href]="product.url" target="_blank" class="link-external">
          <i class="ic ic-external"></i>
          <span>Ver produto no site</span>
        </a>

        <a (click)="closeDetail()" class="btn-close"></a>
        <div
          class="btn-option"
          (click)="toggleOptions()"
          (mouseout)="hideOptions()"
          [class.open]="optionOpen"
        >
          <i></i>
          <i></i>
          <i></i>
          <div (mouseover)="clearOptions()" (mouseout)="hideOptions()">
            <a
              [routerLink]="[
                '/app/produto/' +
                  product.idproduto_geral +
                  '/' +
                  product.codbarra
              ]"
              >Editar cadastro <i class="ic ic-pen"></i
            ></a>
            <a class="dnone">Imprimir <i class="ic ic-print"></i></a>
          </div>
        </div>
      </header>

      <header class="actions" [class.dnone]="!changeDetail">
        <strong>Salve as alterações</strong>
        <button class="btn btn-primary" type="submit">Salvar</button>
        <button
          (click)="cancelEdit()"
          class="btn btn-primary-outline"
          type="button"
        >
          Cancelar
        </button>
      </header>

      <strong>{{ product.descricao }}</strong>

      <div class="tags">
        <span *ngIf="product.embalagem != ''">{{ product.embalagem }}</span>
        <span *ngIf="product.unidade_peso_liquido != 'nan'"
          >{{ product.peso_liquido }}{{ product.unidade_peso_liquido }}</span
        >
      </div>

      <div class="galery">
        <figure>
          <img *ngIf="photo_number_url" [src]="ajustUrl(photo_number_url)" />
        </figure>
        <ul>
          <li
            (click)="selectPhoto(image)"
            *ngFor="let image of product.images; let i = index"
          >
            <img [src]="ajustUrl(image.small)" />
          </li>
        </ul>
      </div>

      <div class="preco" [class.open]="openPrice">
        <div class="header" (click)="openPrice = !openPrice">
          <strong> Preço </strong>
          <div>
            <b
              *ngIf="
                oferta_preco.value &&
                oferta_preco.value != null &&
                oferta_preco.value > 0
              "
              class="promocao"
              >R$ {{ oferta_preco.value | number: ".2" }}</b
            >
            <span class="valor"
              >&nbsp;{{ preco.value | number: ".2" }}&nbsp;</span
            >
          </div>
        </div>
        <div class="infos">
          <div class="frm">
            <div>
              <label>Preço original</label>
              <input
                type="text"
                (keyup)="updatePerc()"
                formControlName="preco"
                currencyMask
                class="form-control"
                [class.text-dash]="oferta_preco.value > 0"
              />
            </div>
            <div>
              <label>Preço promocional</label>
              <div class="ipt-form">
                <input
                  type="text"
                  (keyup)="updatePerc()"
                  formControlName="oferta_preco"
                  currencyMask
                  class="form-control"
                />
                <span [class.promotion]="oferta_preco.value > 0"
                  >{{ oferta_off }}%</span
                >
              </div>
            </div>
          </div>
          <div class="obs">
            <strong> Limite de compra por cliente </strong>
            <div class="frm fdc">
              <input
                type="text"
                formControlName="max_pr_cliente"
                (keyup)="onChangeDetail()"
                currencyMask
                [options]="{ precision: 0, allowNegative: false }"
                class="form-control"
              />
            </div>
          </div>
          <div class="condicao dnone">
            <strong> Condição </strong>
            <div class="frm">
              <div>
                <label>A partir de</label>
                <input type="text" class="form-control" />
              </div>
              <div>
                <label></label>
                <input type="text" class="form-control" />
              </div>
            </div>
          </div>
          <div class="permanencia" [class.dnone]="oferta_preco.value <= 0">
            <strong> Permanência </strong>
            <div class="frm">
              <div>
                <label>Início</label>
                <ng-select
                  (change)="selectedDTInicio()"
                  [items]="permanencia_inicio"
                  formControlName="option_validade_inicial"
                  placeholder="Selecione"
                  bindLabel="text"
                  bindValue="value"
                ></ng-select>
              </div>
              <div>
                <label></label>
                <div
                  class="frm-datepicker"
                  [class.dnone]="option_validade_inicial.value != 'D'"
                >
                  <input
                    type="text"
                    (dateInput)="onChangeDetail()"
                    formControlName="oferta_validade_inicial"
                    class="form-control"
                    [matDatepicker]="pickerInicialDate"
                  />
                  <mat-datepicker-toggle
                    matSuffix
                    [for]="pickerInicialDate"
                  ></mat-datepicker-toggle>
                  <mat-datepicker
                    #pickerInicialDate
                    [startAt]="startDate"
                  ></mat-datepicker>
                </div>
              </div>
            </div>
            <div class="frm mt10">
              <div>
                <label>Fim</label>
                <ng-select
                  [items]="permanencia_fim"
                  formControlName="option_validade_final"
                  placeholder="Selecione"
                  bindLabel="text"
                  bindValue="value"
                ></ng-select>
              </div>
              <div>
                <label></label>
                <div
                  class="frm-datepicker"
                  [class.dnone]="option_validade_final.value != 'D'"
                >
                  <input
                    type="text"
                    (dateInput)="onChangeDetail()"
                    [min]="oferta_validade_inicial.value"
                    formControlName="oferta_validade_final"
                    class="form-control"
                    [matDatepicker]="pickerFinalDate"
                  />
                  <mat-datepicker-toggle
                    matSuffix
                    [for]="pickerFinalDate"
                  ></mat-datepicker-toggle>
                  <mat-datepicker #pickerFinalDate></mat-datepicker>
                </div>
              </div>
            </div>
          </div>
          <div class="obs" [class.dnone]="oferta_preco.value <= 0">
            <strong> Observação </strong>
            <div class="frm fdc">
              <label>Se necessário, detalhe a promoção</label>
              <textarea
                class="text-control"
                (keyup)="onChangeDetail()"
                formControlName="oferta_obs"
              ></textarea>
            </div>
          </div>
        </div>
      </div>

      <div class="estoque" [class.open]="openStoke">
        <div class="header" (click)="openStoke = !openStoke">
          <strong>Estoque</strong>
          <div>
            <b
              *ngIf="
                estoque.value < lower_stock &&
                estoque.value > 0 &&
                !sem_limite.value
              "
              class="estoque"
              >Baixo</b
            >
            <b
              *ngIf="estoque.value == 0 && !sem_limite.value"
              class="sem-estoque"
              >Sem estoque</b
            >
            <span *ngIf="sem_limite.value" class="unlimited">Sem limite</span>
            <span *ngIf="!sem_limite.value" class="qty">{{
              estoque.value
            }}</span>
          </div>
        </div>
        <div class="infos">
          <div class="frm fdc">
            <label>Quantidade em estoque</label>
            <div class="form-w-check">
              <input
                type="text"
                formControlName="estoque"
                [attr.disabled]="sem_limite.value ? true : null"
                (keyup)="onChangeDetail()"
                currencyMask
                [options]="{ precision: 0, allowNegative: false }"
                class="form-control"
              />
              <mat-checkbox
                id="ckPromocao"
                formControlName="sem_limite"
                (change)="onUnlimitedStock()"
                >Sem limite</mat-checkbox
              >
            </div>
          </div>
          <div *ngIf="!sem_limite.value" class="frm fdc">
            <label>Limite mínimo do estoque</label>
            <input
              type="text"
              formControlName="limite_minimo_estoque"
              (keyup)="onChangeDetail()"
              currencyMask
              [options]="{ precision: 0, allowNegative: false }"
              class="form-control"
            />
          </div>
        </div>
      </div>

      <div class="codbarra">
        <ngx-barcode6
          [bc-width]="3"
          [bc-value]="product.codbarra"
          [bc-display-value]="false"
        >
        </ngx-barcode6>
        <strong>{{
          product.codbarra | mask: "0 000000 000000? 00000 0"
        }}</strong>
      </div>
    </form>

    <app-product-detail
      *ngIf="isMobile"
      (onCloseEvent)="onCloseDetailEvent()"
      (onChangeEvent)="onChangeDetailEvent($event)"
    ></app-product-detail>

    <div class="loading" *ngIf="loadingDetail">
      <div class="loadingio-spinner-eclipse-cz3y1wre1nd">
        <div class="ldio-ns36390yc">
          <div></div>
        </div>
      </div>
    </div>
  </aside>
</div>

<div #searchFilter class="search-filter" [class.visible]="showFilter">
  <form [formGroup]="filterFrm" (ngSubmit)="onSubmitFilter()" novalidate>
    <div class="item">
      <strong>Departamentos</strong>
      <div>
        <ng-select
          placeholder="Selecione..."
          formControlName="categorias"
          [multiple]="true"
          [closeOnSelect]="false"
          [items]="categories"
          bindLabel="ds_categoria"
          bindValue="idcategoria"
        >
          <ng-template
            ng-option-tmp
            let-item="item"
            let-item$="item$"
            let-index="index"
          >
            <input
              id="item-{{ index }}"
              type="checkbox"
              [(ngModel)]="item$.selected"
              value="S"
              [ngModelOptions]="{ standalone: true }"
            />
            {{ item.ds_categoria }}
          </ng-template>
        </ng-select>
      </div>
    </div>
    <div class="item">
      <strong>Descrição</strong>
      <div class="jc-start">
        <mat-checkbox formControlName="sem_descricao" class="mr10"
          >Sem descrição</mat-checkbox
        >
        <mat-checkbox formControlName="com_descricao" class="mr10"
          >Com descrição</mat-checkbox
        >
      </div>
    </div>
    <div class="item">
      <strong>Status</strong>
      <div class="jc-start">
        <mat-checkbox formControlName="status_ativo" class="mr10"
          >Ativo</mat-checkbox
        >
        <mat-checkbox formControlName="status_inativo" class="mr10"
          >Inativo</mat-checkbox
        >
      </div>
    </div>
    <div class="item">
      <strong>Fotos</strong>
      <div>
        <mat-checkbox formControlName="sem_fotos" class="mr10"
          >Sem fotos</mat-checkbox
        >
      </div>
    </div>
    <footer>
      <button (click)="onClearFilter()" type="button" class="btn btn-link">
        Limpar filtros
      </button>
      <button (click)="onSubmitFilter()" type="button" class="btn btn-primary">
        Aplicar filtro
      </button>
    </footer>
  </form>
</div>

<div
  class="modal"
  [class.dnone]="!modalImportOpen"
  [class.open]="modalImportOpen"
>
  <div class="modal-content modal-xlarge modal-import">
    <app-import-file
      [actions]="true"
      [inmodal]="true"
      (onChangeEvent)="onChangeImport($event)"
      (onSuccessEvent)="onSuccessImport($event)"
      (onCancelEvent)="onCancelModalImport($event)"
    ></app-import-file>
  </div>
</div>

<div *ngIf="isExportLoading" class="modal" [class.open]="modalExportOpen">
  <div class="modal-content modal-medium modal-export">
    <h3>Exportando...</h3>
    <div class="tab-loading">
      <div class="loadingio-spinner-eclipse-cz3y1wre1nd">
        <div class="ldio-ns36390yc">
          <div></div>
        </div>
      </div>
    </div>
  </div>
</div>
